import { Component, inject, OnInit, signal } from '@angular/core';
import { MenuService } from './menu.service';
import { AsyncPipe } from '@angular/common';
import { AuthService } from '@core/service/auth.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-menu-screen',
  standalone: true,
  imports: [AsyncPipe, RouterLink],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuScreenComponent implements OnInit {
  sidebarMenuMyAccount = signal<any[]>([])
  sidebarMenuOtherAccount = signal<any[]>([])
  
  private drawer = inject(MenuService)
  private authService = inject(AuthService)
  
  isOpen$ = this.drawer.isOpen$;

  ngOnInit(): void {
      this.setSideBar();
  }

  setSideBar() {
    this.sidebarMenuMyAccount.set([
      {
        id: 0,
        name: 'Settings',
        route: 'settings',
        activeRouteName: ['/settings'],
      },
      {
        id: 1,
        name: 'Personal Information',
        route: 'personal-information',
        activeRouteName: ['/personal-information'],
      },
      {
        id: 2,
        name: 'Insurance Information',
        route: 'insurance-information',
        activeRouteName: ['/insurance-information'],
      },
      {
        id: 3,
        name: 'My Doctors',
        route: 'my-doctors',
        activeRouteName: ['/my-doctors'],
      },
      {
        id: 4,
        name: 'My Prescriptions',
        route: 'my-prescriptions',
        activeRouteName: ['/my-prescriptions'],
      },
      {
        id: 5,
        name: 'Imaging & Test Results',
        route: 'imaging-test-results',
        activeRouteName: ['/imaging-test-results'],
      },
      {
        id: 6,
        name: 'Surgeries & Procedures',
        route: 'surgeries-procedures',
        activeRouteName: ['/surgeries-procedures'],
      },
      {
        id: 7,
        name: 'Diagnoses & Conditions',
        route: 'diagnoses-conditions',
        activeRouteName: ['/diagnoses-conditions'],
      },
      {
        id: 8,
        name: 'My Submissions',
        route: 'my-submissions',
        activeRouteName: ['/my-submissions'],
      }
    ])

    this.sidebarMenuOtherAccount.set([
      {
        id: 0,
        name: 'Child 1',
        route: 'child1',
        activeRouteName: ['/child1'],
      },
      {
        id: 1,
        name: 'Child 2',
        route: 'child2',
        activeRouteName: ['/child2'],
      },
      {
        id: 2,
        name: 'Caregiver Responsibilities',
        route: 'caregiver-responsibilities',
        activeRouteName: ['/caregiver-responsibilities'],
      },
      {
        id: 3,
        name: 'Mother',
        route: 'mother',
        activeRouteName: ['/mother'],
      },
      {
        id: 4,
        name: 'Father-In-Law',
        route: 'fatherInLaw',
        activeRouteName: ['/father-in-law'],
      },
      {
        id: 5,
        name: 'Uncle',
        route: 'uncle',
        activeRouteName: ['/uncle'],
      }
    ])
  }

  close() {
    this.drawer.close();
  }
}
